var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWarning = function SvgWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M3.35964 30H28.6404C31.2255 30 32.837 27.1524 31.5445 24.8846L18.9041 2.70087C17.6115 0.433044 14.3885 0.433044 13.0959 2.70087L0.455542 24.8846C-0.837032 27.1524 0.774488 30 3.35964 30Z",
    fill: "#DB973A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47012 26.0002H23.5301C25.0701 26.0002 26.0301 24.3302 25.2601 23.0002L17.7301 9.99018C16.9601 8.66018 15.0401 8.66018 14.2701 9.99018L6.74012 23.0002C5.97012 24.3302 6.93012 26.0002 8.47012 26.0002ZM16.0001 19.0002C15.4501 19.0002 15.0001 18.5502 15.0001 18.0002V16.0002C15.0001 15.4502 15.4501 15.0002 16.0001 15.0002C16.5501 15.0002 17.0001 15.4502 17.0001 16.0002V18.0002C17.0001 18.5502 16.5501 19.0002 16.0001 19.0002ZM17.0001 23.0002H15.0001V21.0002H17.0001V23.0002Z",
    fill: "#DB973A"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning.bcefaeb5.svg";
export { ForwardRef as ReactComponent };